import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { splashScreenFormDefault } from "@factory/form/form.default";
import { SplashScreenFormRule, SplashScreenFormSchema } from "@factory/form/form.rule";
import { useQyCreateSplashScreen } from "@factory/query/splash-screen.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewSplashScreen() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateSplashScreen } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New SplashScreen is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addSplashScreen, isLoading: isCreating } =
    useQyCreateSplashScreen(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<SplashScreenFormSchema>({
    defaultValues: splashScreenFormDefault,
    resolver: zodResolver(SplashScreenFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: SplashScreenFormSchema) => {
    const formData = mapCreateSplashScreen(form);
    addSplashScreen(formData);
  };
  const handleValidateError = (err: FieldErrors<SplashScreenFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
